
export const claims = {
    userType: "user_type",
    userRole: "user_role",
    accountId: "account_id",
    isUser: "isUser",
    isCustomerAdmin: "isCustomerAdmin",
    canViewAdminMenu: "canViewAdminMenu",
    canCrudAccounts: "canCrudAccounts",
    canCrudAccountUsers: "canCrudAccountUsers",
    canCrudEmployeeUsers: "canCrudEmployeeUsers",
    canCrudCodingQueues: "canCrudCodingQueues",
    canCrudEmrVendors: "canCrudEmrVendors",

    canViewCodingMenu: "canViewCodingMenu",
    canViewMyCodingQueue: "canViewMyEventQueue",
    canViewCodingTeamQueue: "canViewCodingTeamQueue",
    canViewAllEventsFromTeamQueue: "canViewAllEventsFromTeamQueue",
    canViewCodingGroupQueue: "canViewCodingGroupQueue",
    canViewCodingAllQueues: "canViewCodingAllQueues",
    canCrudCodingEvent: "canCrudCodingEvent",
    canCrudCodingEventWorksheet: "canCrudCodingEventWorksheep",
    canCrudPendingEvents: "canCrudPendingEvents",
    canUseCodingEventImport: "canUseCodingEventImport",

    canCrudCustomerCodingQueue: "canCrudCustomerCodingQueue"
};

export const userRoles = {
    reviewer: "REVIEWER",
    codingTeamLead: "CODING_TEAM_LEAD",
    extCodingTeamLead: "EXT_CODING_TEAM_LEAD",
    codingManager: "CODING_MANAGER",
    codingSeniorManager: "CODING_SENIOR_MANAGER",
    administrator: "ADMINISTRATOR"
}

export const claimValues = {
    createReadUpdateDelete: "1111",
    readUpdate: "0110",
    read: "0100",
    isTrue: "true",
    isFalse: "false"
};